export default __webpack_public_path__ + "static/media/coach.e345f92f.jpg";